export const PESAN_GET = 'PESAN_GET';
export const STATUS_UPDATE = 'STATUS_UPDATE';